import React from 'react'
import styled from 'styled-components'
import {Card, SignInLayout} from '../components/SigninLayout'
import {Icon} from '@startlibs/components'
import {FormattedMessage} from "react-intl";

const DeletedAccountPage = styled(SignInLayout) `
  color: rgba(0,0,0,0.5);
  h2 {
    margin-bottom: 0.5rem;
    color: rgba(0,0,0,0.7);
    font-size: 22px;
  }
  ${Icon} {
    font-size: 90px;
    margin-bottom: 0.75rem;
    display: block;
  }
`

export class DeletedAccountError extends React.PureComponent {

  render() {
    const {system} = this.props
    return <DeletedAccountPage system={system}>
      <Card centralizedContent>
          <Icon icon="warning"/>
          <h2><FormattedMessage
            defaultMessage="This account has been removed"
            description="Deleted account page title"
          /></h2>
          <p><FormattedMessage
            defaultMessage="Please contact your administrator for more details."
            description="Deleted account page message"
          /></p>
      </Card>
    </DeletedAccountPage>
  }

}
